interface ContentLoadingProps {
  message?: string;
}

export function ContentLoading({ message }: ContentLoadingProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
      {message && (
        <p className="mt-3 text-sm text-surface-500 dark:text-surface-400">{message}</p>
      )}
    </div>
  );
}
